import { useCallback } from 'react';
import { pick } from 'ramda';

import { usePortletConfig } from 'js/components/system/Portlet';

import { DYNAMIC_CATEGORIES } from 'js/app/components/main/Games/constants';
import { useGameComponentConfig } from 'js/app/components/main/Games/hooks/useGameComponentConfig';
import { useGamesSelector } from 'js/app/components/main/Games/store/context';
import { useRecentlyGamesSelector } from 'js/app/store/hooks/useRecentlyGames';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

export const useFilterDynamicCategory = () => {
    const { pggGameList: pggGameLists } = useGamesSelector();
    const { isLoggedIn, futureAnthemsList } = useUserSelector(pick(['isLoggedIn', 'futureAnthemsList']));
    const { isFavoritesFetching, favoriteGames } = useAppSelector(pick(['isFavoritesFetching', 'favoriteGames']));
    const { isShowEmptyRecently, isShowEmptyFavourities } = useGameComponentConfig();
    const { recentlyPlayedLoading, recentlyPlayedGames } = useRecentlyGamesSelector();
    const { customCategories: { category: customCategories = [] } = {} } = usePortletConfig();

    return useCallback(category => {
        switch (category.name) {
            case DYNAMIC_CATEGORIES.ALL_CATEGORY: {
                return true;
            }
            case DYNAMIC_CATEGORIES.RECENTLY: {
                return isShowEmptyRecently || recentlyPlayedLoading || recentlyPlayedGames?.length;
            }
            case DYNAMIC_CATEGORIES.FAVOURITES: {
                return isShowEmptyFavourities || isFavoritesFetching || favoriteGames?.length;
            }
            default: {
                const {
                    futureAnthemsEnabled,
                    futureAnthemsRecommendationType
                } = customCategories.find(({ categoryName }) => categoryName === category.name) || {};

                if (futureAnthemsEnabled && isLoggedIn) {
                    const {
                        isFetchStarted: isFutureAnthemsFetchStarted,
                        fetched: isFutureAnthemsFetched,
                        gamesList: futureAnthemsEnabledGameList = []
                    } = futureAnthemsList[futureAnthemsRecommendationType] || {};

                    return !futureAnthemsList[futureAnthemsRecommendationType]
                        || isFutureAnthemsFetchStarted
                        || category.gameCodes?.length
                        || isFutureAnthemsFetched && futureAnthemsEnabledGameList.length;
                }

                if (category.pgg2?.enabled) {
                    const {
                        isFetchStarted: isPggFetchStarted,
                        fetched: isPggFetched,
                        pggGameList = []
                    } = pggGameLists[category.name] || {};

                    return isPggFetchStarted
                        || category.gameCodes?.length
                        || isPggFetched && pggGameList.length;
                }

                return category.gameCodes?.length;
            }
        }
    }, [
        favoriteGames?.length, isFavoritesFetching, isShowEmptyFavourities, isShowEmptyRecently,
        recentlyPlayedGames?.length, recentlyPlayedLoading, customCategories, isLoggedIn,
        futureAnthemsList, pggGameLists
    ]);
};
